import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ActivityBadge } from 'components/sections/dashboard'
import { ElevatedBox, Card } from 'components/layout'
import { apiDownloadImage } from 'helpers/decorators/api'
import styles from './aj-card.styl'

@apiDownloadImage()
class AJCard extends Component {
  static propTypes = {
    title: PropTypes.any,
    showHeading: PropTypes.bool,
    onDownloadImage: PropTypes.func,
    onClick: PropTypes.func,
    bottom: PropTypes.object,
    right: PropTypes.object,
    downloadedImage: PropTypes.string,
    activitySection: PropTypes.string,
    url: PropTypes.string,
  }

  componentWillMount() {
    this.getDownloadedImage()
  }
  componentWillUpdate(nexProps) {
    if (nexProps.url && nexProps.url !== this.props.url) {
      this.getDownloadedImage()
    }
  }

  getDownloadedImage = () => {
    const { downloadedImage, url, onDownloadImage } = this.props

    url && !downloadedImage && onDownloadImage(url)
  }

  render() {
    const {
      activitySection,
      downloadedImage,
      showHeading,
      onClick,
      bottom,
      right,
      title,
    } = this.props

    return (
      <ElevatedBox
        onClick={onClick}
        clickable
      >
        <Card.Wrap>
          <Card.Left>
            <div className={styles.badge}>
              {downloadedImage ?
                <div
                  className={styles.img}
                  style={{ backgroundColor: 'white', backgroundImage: `url(${downloadedImage})` }}
                />
                : <ActivityBadge activitySection={activitySection} plain large />
              }
            </div>
          </Card.Left>

          <Card.Content>
            <Card.Top>
              <Card.Middle>
                <h3 className={`${styles.description} ${showHeading ? styles.heading : ''}`}>
                  {title}
                </h3>
                <div className={styles.bottom}>
                  {bottom}
                </div>
              </Card.Middle>
              <Card.Right>
                <div className={styles.right}>
                  {right}
                </div>
              </Card.Right>
            </Card.Top>
          </Card.Content>
        </Card.Wrap>
      </ElevatedBox>
    )
  }
}

export default AJCard
